import { Controller } from '@hotwired/stimulus'
import { freshSession } from './support/party_setup_request'

// Opt-in forms only. Refresh BEFORE submitting so an expired token cannot
// navigate away from entered details. Never replay a submitted form.
export default class extends Controller {
    connect() {
        this.onSubmit = this.prepare.bind(this)
        this.element.addEventListener('submit', this.onSubmit, true)
    }

    disconnect() {
        this.element.removeEventListener('submit', this.onSubmit, true)
    }

    async prepare(event) {
        if (this.ready) return
        event.preventDefault()
        event.stopImmediatePropagation()
        if (this.pending) return
        this.pending = true
        const buttons = [...this.element.querySelectorAll('[type="submit"]')]
        const disabled = buttons.map(button => button.disabled)
        buttons.forEach(button => { button.disabled = true })
        let restored = false
        const restore = () => {
            if (restored) return
            buttons.forEach((button, i) => { button.disabled = disabled[i] })
            restored = true
        }
        try {
            const session = await freshSession()
            if (!this.element.isConnected) return
            let token = this.element.querySelector('input[name="authenticity_token"]')
            if (!token) {
                token = document.createElement('input')
                token.type = 'hidden'
                token.name = 'authenticity_token'
                this.element.append(token)
            }
            token.value = session.csrf_token
            this.element.querySelector('[data-session-error]')?.remove()
            restore()
            // The normal validator / Turbo / native form flow still owns submission.
            this.ready = true
            if (event.submitter) this.element.requestSubmit(event.submitter)
            else this.element.requestSubmit()
        } catch (_) {
            let alert = this.element.querySelector('[data-session-error]')
            if (!alert) {
                alert = document.createElement('div')
                alert.dataset.sessionError = ''
                alert.className = 'alert alert-warning'
                alert.setAttribute('role', 'alert')
                this.element.prepend(alert)
            }
            alert.textContent = 'We couldn’t reconnect. Your details are still here. Please try again.'
        } finally {
            restore()
            this.ready = false
            this.pending = false
        }
    }
}
